var _title, _desc, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDots = function SvgDots(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "16px",
    viewBox: "0 0 10 16",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-623.000000, -427.000000)",
    fill: "#DBE3EB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(623.000000, 427.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2,
    cy: 8,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8,
    cy: 8,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2,
    cy: 14,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8,
    cy: 14,
    r: 2
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDots, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dots.2298f04c.svg";
export { ForwardRef as ReactComponent };